//TODO: These URLs need to be changed per project to enable Cognito auth
//Need to match deploy URL

const baseUrls = {
  staging: 'https://int-alb.staging.experience.jaguarlandrover.com/',
  dev: 'https://int-alb.dev.experience.jaguarlandrover.com/', //No dev deploy
  production: 'https://int-alb.experience.jaguarlandrover.com/', //https://d1x3m512bjhezh.cloudfront.net
}
const env = process.env.NODE_ENV
const baseUrl = baseUrls[env]
export const urls = {
  base: baseUrl,
  import: baseUrl + 'vouchers/import',
  vouchers: baseUrl + 'vouchers',
  search: baseUrl + 'vouchers/search',
  reports: baseUrl + 'vouchers/reports',
}
